export interface ClinicLite {
  id: string;
  name: string;
  customer_id: string;
  customer_name: string;
}

export interface VisibleClinics {
  activeClinicId: string | null;
  visibleClinicIds: string[];
  clinicsById: Record<string, { id: string; name: string }>;
  hasMultipleVisible: boolean;
}

/**
 * Deriva o conjunto de clínicas "visíveis" para consolidação de histórico:
 * todas as clínicas que o usuário acessa dentro do customer da clínica ativa.
 */
export function deriveVisibleClinics(
  accessibleClinics: ClinicLite[],
  activeClinicId: string | null,
): VisibleClinics {
  const active = accessibleClinics.find((c) => c.id === activeClinicId) ?? null;
  const visible = active
    ? accessibleClinics.filter((c) => c.customer_id === active.customer_id)
    : [];
  const clinicsById = Object.fromEntries(
    visible.map((c) => [c.id, { id: c.id, name: c.name }]),
  );
  return {
    activeClinicId: active?.id ?? null,
    visibleClinicIds: visible.map((c) => c.id),
    clinicsById,
    hasMultipleVisible: visible.length > 1,
  };
}

/**
 * Resolve a lista de clínicas a aplicar num filtro de leitura de histórico.
 * Prioriza o conjunto consolidado (clínicas visíveis); cai para a clínica única
 * quando o conjunto está vazio; retorna `null` quando não há clínica (sem filtro,
 * deixando a RLS restringir). Um conjunto de um único id é equivalente, em
 * performance, a um `.eq` — ambos usam o índice de `clinic_id`.
 */
export function resolveHistoryClinicScope(
  clinicIds: string[] | null | undefined,
  fallbackClinicId: string | null | undefined,
): string[] | null {
  if (clinicIds && clinicIds.length > 0) return clinicIds;
  if (fallbackClinicId) return [fallbackClinicId];
  return null;
}
